import React, { memo } from 'react';

import LocalMediaSlide from './LocalMediaSlide';
import ServerMediaSlide from './ServerMediaSlide';

function MediaSelectSlide({ slide }) {
  const { isCustom } = slide;

  if (isCustom) {
    return <LocalMediaSlide slide={slide} />;
  }

  return <ServerMediaSlide slide={slide} />;
}

export default memo(MediaSelectSlide, (prevProps, nextProps) => {
  return (
    prevProps.slide.id === nextProps.slide.id &&
    prevProps.slide.mediaType === nextProps.slide.mediaType &&
    prevProps.slide.reaction === nextProps.slide.reaction
  );
});
